import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "5666a188-48b1-465f-b5ba-c25f47b7243b",
  solutionType: "text-or-number",
  type: "custom010303",
  options: {
    shuffle: true,
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: 5,
};
